module.exports = __webpack_public_path__ + "media/icons/white-applications-2289e6ce.png";